import React, {Component} from "react"
import Loader from 'react-loader-spinner'


 class LoaderSpinner extends Component {
  
    render() {
     return(
      <div className={"loader-fullscreen"}>
         <div  className={"centralizarDiv"}>
               <Loader
                  type="ThreeDots"
                  color="#f2a404"
                  height={200}
                  width={200}
                  //3 secs 
               />
         </div>
      </div>
     );
    }
 }
 export default LoaderSpinner;